// extracted by mini-css-extract-plugin
export default {"root":"breadcrumbs_root__WkW-q","divider":"breadcrumbs_divider__MxuGS","segment":"breadcrumbs_segment__+-ukP","icon":"breadcrumbs_icon__0RoT6"};